// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_refunds_process_title = /** @type {(inputs: {}) => string} */ () => {
	return `How Refunds Work`
};

const el_refunds_process_title = /** @type {(inputs: {}) => string} */ () => {
	return `Πώς Λειτουργούν οι Επιστροφές Χρημάτων`
};

const ru_refunds_process_title = /** @type {(inputs: {}) => string} */ () => {
	return `Как происходит возврат средств`
};

const he_refunds_process_title = /** @type {(inputs: {}) => string} */ () => {
	return `איך עובדים ההחזרים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refunds_process_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refunds_process_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refunds_process_title", locale)
	if (locale === "en") return en_refunds_process_title(inputs)
	if (locale === "el") return el_refunds_process_title(inputs)
	if (locale === "ru") return ru_refunds_process_title(inputs)
	if (locale === "he") return he_refunds_process_title(inputs)
	return "refunds_process_title"
};